import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SectionHeader = ({ className, children }) => {
  return (
    <div className={classNames('section-name', className)}>
      <h1>{children}</h1>
      <span className="separator-middle" />
    </div>
  );
};

SectionHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SectionHeader;
